import UrlFetchStatus from '@/enums/UrlFetchStatus';

/**
 * Returns a color name based on the provided fetch status.
 * @param status - The fetch status (optional).
 * @returns A string representing the color.
 */
export function getFetchStatusColor(status?: UrlFetchStatus): string {
    switch (status) {
        case UrlFetchStatus.FETCHED:
            return 'green';
        case UrlFetchStatus.TO_FETCH:
            return 'warning';
        case UrlFetchStatus.FAILED:
            return 'red';
        default:
            return 'grey lighten-1';
    }
}

/**
 * Returns a display text based on the provided fetch status.
 * @param status - The fetch status (optional).
 * @returns A string representing the text.
 */
export function getFetchStatusText(status?: UrlFetchStatus): string {
    switch (status) {
        case UrlFetchStatus.FETCHED:
            return 'Fetched';
        case UrlFetchStatus.TO_FETCH:
            return 'To Fetch';
        case UrlFetchStatus.FAILED:
            return 'Failed';
        default:
            return 'Pending';
    }
}
